import api from '../api';

/**
 * Fetches coupons for a specific user based on their phone number.
 *
 * @param {string} userId - The Id of the user.
 * @return {Promise<Object>} - The response from the API containing the user's coupons.
 * @throws {Error} - If the request fails.
 */
const getUserCoupons = async (userId) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/coupons?userId=${encodeURIComponent(userId)}`;

  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching user coupons:', error);
    throw error;
  }
}

export default getUserCoupons;
